import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/data/clientsData";

export const StickyCTA = () => {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;
  const wa = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent("Hi Stagehook, I need a quote for an exhibition stand.")}`;
  return (
    <div data-testid="sticky-cta" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-2" style={{ background: "linear-gradient(180deg, transparent, rgba(7,7,10,0.95) 40%)" }}>
      <div className="flex gap-2">
        <Link to="/contact" data-testid="sticky-quote" className="btn-primary flex-1 justify-center text-sm py-3">
          Free 3D design + quote <ArrowUpRight size={15} />
        </Link>
        <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp" className="btn-ghost text-sm py-3 px-4">WhatsApp</a>
      </div>
    </div>
  );
};

export default StickyCTA;
